var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmojiSmileColored(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 17.5161C10.3347 17.5161 8.75459 16.8788 7.77289 15.8114C7.59181 15.6149 7.60465 15.3087 7.80125 15.1278C7.99784 14.9469 8.3044 14.9595 8.48511 15.1563C9.28686 16.0281 10.6009 16.5484 11.9999 16.5484C13.399 16.5484 14.713 16.0281 15.5148 15.1563C15.6955 14.9595 16.0021 14.9469 16.1987 15.1278C16.3953 15.3087 16.4081 15.6149 16.227 15.8114C15.2453 16.8788 13.6651 17.5161 11.9999 17.5161Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93541 10.5097C7.40094 10.5097 6.96768 10.0764 6.96768 9.54192V8.76773C6.96768 8.23327 7.40094 7.8 7.93541 7.8C8.46988 7.8 8.90314 8.23327 8.90314 8.76773V9.54192C8.90314 10.0764 8.46988 10.5097 7.93541 10.5097Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0644 10.5097C15.5299 10.5097 15.0967 10.0764 15.0967 9.54192V8.76773C15.0967 8.23327 15.5299 7.8 16.0644 7.8C16.5989 7.8 17.0321 8.23327 17.0321 8.76773V9.54192C17.0321 10.0764 16.5989 10.5097 16.0644 10.5097Z",
    fill: "#333333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiSmileColored);
export default __webpack_public_path__ + "static/media/emoji-smile-colored.772ee76189f2e6e06d25a787bbdac6ea.svg";
export { ForwardRef as ReactComponent };